var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reMain" },
    [
      _c("RealTitle", { attrs: { titleInfo: _vm.titleInfo } }),
      _vm._v(" "),
      _c("div", { staticClass: "reMainContent" }, [
        _c("div", { staticClass: "reNewsContent" }, [
          _c("div", { staticClass: "matchTitle" }, [
            _vm._v("师生技能大赛注册信息修改"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "newsList" },
            [
              _c(
                "el-form",
                {
                  ref: "regForm",
                  staticClass: "registerForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.regRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "注册类型：", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择注册类型",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        [
                          _c(
                            "el-option",
                            { attrs: { label: "教师注册", value: 2 } },
                            [_vm._v("教师注册")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-option",
                            { attrs: { label: "学生注册", value: 1 } },
                            [_vm._v("学生注册")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.form.type == 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "职称：", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入职称" },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证号：", prop: "idCard" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入身份证号" },
                        model: {
                          value: _vm.form.idCard,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "idCard", $$v)
                          },
                          expression: "form.idCard",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码：", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号码" },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电子邮箱：", prop: "mail" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入电子邮箱" },
                        model: {
                          value: _vm.form.mail,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mail", $$v)
                          },
                          expression: "form.mail",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "性别：", prop: "sex" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择性别" },
                          model: {
                            value: _vm.form.sex,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sex", $$v)
                            },
                            expression: "form.sex",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "男", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "女", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "民族：", prop: "nation" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入民族" },
                        model: {
                          value: _vm.form.nation,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nation", $$v)
                          },
                          expression: "form.nation",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所学专业：", prop: "major" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入所学专业" },
                        model: {
                          value: _vm.form.major,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "major", $$v)
                          },
                          expression: "form.major",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.form.type == 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "所在年级：", prop: "classes" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入所在年级" },
                            model: {
                              value: _vm.form.classes,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "classes", $$v)
                              },
                              expression: "form.classes",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.form.type == 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "电话：", prop: "tel" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入电话" },
                            model: {
                              value: _vm.form.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mobile", $$v)
                              },
                              expression: "form.mobile",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮编：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入邮编" },
                        model: {
                          value: _vm.form.zipCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "zipCode", $$v)
                          },
                          expression: "form.zipCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "传真：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入传真" },
                        model: {
                          value: _vm.form.fax,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fax", $$v)
                          },
                          expression: "form.fax",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选拔赛成绩：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入选拔赛成绩" },
                        model: {
                          value: _vm.form.achievement,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "achievement", $$v)
                          },
                          expression: "form.achievement",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属学校：", prop: "schoolId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择所属学校",
                            filterable: "",
                          },
                          model: {
                            value: _vm.form.schoolId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "schoolId", $$v)
                            },
                            expression: "form.schoolId",
                          },
                        },
                        [
                          _vm._l(_vm.schoolList, function (i, j) {
                            return [
                              _c(
                                "el-option",
                                {
                                  key: j,
                                  attrs: { label: i.name, value: i.id },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.onchange(i)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(i.name))]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "descInfo" }, [
                    _vm._v(
                      "\n            *登录账号为：身份证号，密码默认为：sc123!@#\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btnMode" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.editInfo("regForm")
                            },
                          },
                        },
                        [_vm._v("\n              修改\n            ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }